import { slugifyCustomFieldKey } from "./partner-api.ts";

export type CurlAction = "create_lead" | "get_lead" | "list_leads" | "get_funnels";

export type CurlBuilderInput = {
  baseUrl: string;
  apiKey: string;
  action: CurlAction;
  name: string;
  phone: string;
  email: string;
  funnelId: string;
  stage: string;
  externalId: string;
  customFields: Record<string, string>;
  tagIds?: string[];
  assignedMemberId?: string;
  includeIdempotency?: boolean;
  sendGreeting?: boolean;
  agentId?: string;
  integrationId?: string;
  leadId?: string;
};

export const PARTNER_API_ENDPOINTS = [
  ["GET", "/v1/leads", "Listar leads (cada item traz custom_fields)"],
  ["POST", "/v1/leads", "Criar ou atualizar (telefone / external_id), com custom_fields livres"],
  ["GET", "/v1/leads/:id", "Um lead, com os custom_fields dele"],
  ["PUT", "/v1/leads/:id", "Atualizar lead (mescla custom_fields)"],
  ["DELETE", "/v1/leads/:id", "Excluir lead"],
  ["GET", "/v1/funnels", "IDs dos funis"],
  ["GET", "/v1/funnels/:id/stages", "Colunas (slug) do funil"],
  ["GET", "/v1/tags", "Tags do workspace"],
  ["GET", "/v1/openapi.json", "Especificação OpenAPI"],
] as const;

export function buildPartnerCurl(input: CurlBuilderInput): string {
  const key = input.apiKey.trim() || "fab_COLE_SUA_CHAVE_AQUI";
  const base = input.baseUrl.replace(/\/$/, "");
  const headers = [
    `  -H "X-Api-Key: ${key}"`,
    `  -H "Content-Type: application/json"`,
  ];

  const authOnly = [`  -H "X-Api-Key: ${key}"`];

  if (input.action === "list_leads") {
    return [`curl -sS -X GET "${base}/v1/leads?limit=20"`, ...authOnly].join(" \\\n");
  }
  if (input.action === "get_lead") {
    const id = (input.leadId || "").trim() || "LEAD_ID";
    return [`curl -sS -X GET "${base}/v1/leads/${id}"`, ...authOnly].join(" \\\n");
  }
  if (input.action === "get_funnels") {
    return [`curl -sS -X GET "${base}/v1/funnels"`, ...authOnly].join(" \\\n");
  }

  const custom: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input.customFields)) {
    const key = slugifyCustomFieldKey(k);
    if (!key || !String(v).trim()) continue;
    custom[key] = String(v).trim();
  }
  const body: Record<string, unknown> = {
    name: input.name.trim() || "Maria Silva",
    phone: input.phone.trim() || "11999999999",
  };
  if (input.email.trim()) body.email = input.email.trim();
  if (input.funnelId) body.funnel_id = input.funnelId;
  if (input.stage) body.stage = input.stage;
  if (input.externalId.trim()) body.external_id = input.externalId.trim();
  if (Object.keys(custom).length > 0) body.custom_fields = custom;
  const tagIds = (input.tagIds || []).filter(Boolean);
  if (tagIds.length > 0) body.tag_ids = tagIds;
  if (input.assignedMemberId) body.assigned_member_id = input.assignedMemberId;
  if (input.sendGreeting) {
    body.send_greeting = true;
    if (input.agentId) body.agent_id = input.agentId;
    if (input.integrationId) body.integration_id = input.integrationId;
  }

  if (input.includeIdempotency !== false) {
    headers.splice(1, 0, `  -H "Idempotency-Key: form-001"`);
  }

  return [
    `curl -sS -X POST "${base}/v1/leads"`,
    ...headers,
    `  --data-binary '${JSON.stringify(body).replace(/'/g, `'\\''`)}'`,
  ].join(" \\\n");
}
